
<template>
<section class="content">

  <div class="card">
              <!-- <h4>Status</h4> -->

                  <div class="dash">
                    <h3>{{ Total }}</h3>
                    <p>Registrations</p>
                  </div>

                  <div class="dash">
                    <h3>{{ Total - Arrived }}</h3>
                    <p>Not Arrived</p>
                  </div>

                  <div class="dash">
                    <h3>{{ Arrived }}</h3>
                    <p>Arrived</p>
                  </div>


        
  </div>



  <div class="">
    
    <div class="row">

      <div class="col-md-6">
      
        <h3>Category Wise Total</h3>

        <table class="table">

          <thead>
            <th>Total</th>
            <th>Arrived</th>
            <th>Not Arrived</th>           
          </thead>

          <tbody>
            <template v-for="S in stats">
              <tr>
                <td>{{S._id}}</td>
                <td>{{S.arrived}}</td>
                <td>{{S.notArrived}}</td>
              </tr>
            </template>
          </tbody>


        </table>        

      </div>


      <div class="col-md-6">

        <!-- <h3>ID Card Stats</h3> -->
<!-- 
        <table class="table">

          <thead>
            <th>Total</th>
            <th>Saved</th>
            <th>Pending</th>
            <th>Gen in April</th>           
          </thead>

          <tbody>
            <template v-for="S in idCardStats">
              <tr>
                <td>{{S._id}}</td>
                <td>{{S.saved}}</td>
                <td>{{S.pending}}</td>
                <td>{{S.alreadyGenerated}}</td>
              </tr>
            </template>
          </tbody>


        </table>         -->

      </div>


      </div>


    </div>

        
  </div>


      <!-- /.box-header -->
      <div class="box-body">

        <br>
        <!-- Button trigger modal -->
        <!-- <button type="button" class="btn btn-outline-primary button" data-toggle="modal" data-target="#exampleModalCenter">
          Add Walk-In 
        </button> -->

      <transition name="fade">

        <div class="row loadingContainer" v-if="showPleaseWait">
          <h1>{{alertMessage}}</h1>
        </div>

      </transition>

      </div>


  <div class="row loadingContainer" v-if="showLoading">
    <i class="fa fa-circle-o-notch fa-spin fa-5x fa-fw loading"></i>
  </div>

  <hr/>

  <div class="row center-block" v-if="showTable">

    <div class="box">
      <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">

        <div class="row box-body">
          <div class="col-sm-12 table-responsive" id="Feedbacks">

            <table aria-describedby="example1_info" role="grid" id="example" style="width:100%" class="display table table-bordered table-striped dataTable wrap">
              <thead>
                <tr role="row">
                  <!-- <th>QR Code</th> -->
                  <!-- <template v-for="(value, key) in tableHeader.customFields.rsvpInfo">
                    <th>{{capitalizeFirstLetter(key)}}</th>
                  </template> -->

                  <th>New UID</th>
                  <th>On The Spot</th>

                  <th>Selfie</th>

                  <template v-for="x in tableHeader.customFields.formFields">
                    <th>{{capitalizeFirstLetter(x.label)}}</th>
                  </template>

                  <th>QR Code</th>
                  <th>ID Card</th>
                  <th>Send Whatsapp</th>
                  <th>Send Gen ID Card Link</th>
                  <!-- <th>Send ID Card</th> -->
                  <!-- <th>Last Updated</th> -->
                  <th>Current Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(S,index) in List">
                <tr class="even" role="row">

                  <td> {{ S.customFields.newUid }} </td>

                  <td>
                    <p v-if="'S.customFields.batch' == 'WalkIn'">Yes</p>
                    <p v-if="'S.customFields.batch' != 'WalkIn'">No</p>
                  </td>
                  
                  <td>
                    <!-- <img :src="S.customFields.idCardInfo.imageUrl" style="width: 40px" v-if="S.customFields.idCardInfo.imageUrl" />
                    <p v-if="S.customFields.idCardInfo.imageUrl == ''">Not Clicked</p> -->
                  </td>


                  <!-- <template v-for="x in tableHeader.customFields.formFields"> -->

                          <template v-for="(value, key) in S.customFields.rsvpInfo">

                            <td>
                              <!-- {{value}} -->
                              <template v-if="typeof value === 'string' && value.includes('https://firebasestorage')">
                                <a :href="value" target="_blank">View</a>
                              </template>

                              <template v-else>
                                {{ value }}
                              </template>                            
                            </td>                            

                          </template>                  

                  <!-- </template>                   -->


                  <!-- <td class="sorting_1">
                    <p v-if="S.linkOpened == false">No</p>
                    <p v-if="S.linkOpened == true">Yes</p>
                  </td> -->
                  <td class="sorting_1">
                      <a :href="S.eTicketUrl" target="_blank">View</a>
                   </td>

                  <td class="sorting_1">

                    <!-- <p v-if="S.customFields.repeat == 'Yes'">Generated in April</p>
                    
                    <a :href="S.customFields.idCardInfo.idCardUrl" v-if="S.customFields.idCardInfo.idCardUrl != '' && S.customFields.repeat == ''" target="_blank">View</a>
                    <p v-if="S.customFields.idCardInfo.idCardUrl == '' && S.customFields.repeat == ''" id="labelNotArrived">PENDING</p>
                   -->
                  </td>

                   <td class="sorting_1">

                    <button type="button" class="btn btn-outline-primary" v-on:click="sendWhatsappPrompt(S);">
                        Send Whatsapp
                    </button>

                  </td>
                  
                   <td class="sorting_1">

                    <button type="button" class="btn btn-outline-primary" v-on:click="sendIDCardPrompt(S);">
                        Send Link
                    </button>


                    <!-- <button type="button" class="btn btn-outline-primary" v-on:click="sendIDCardPrompt(S);" v-if="S.customFields.idCardInfo.idCardUrl == ''">
                        Send ID Card
                    </button> -->

                    <!-- <p v-if="S.customFields.idCardInfo.idCardUrl == ''" id="labelNotArrived">PENDING</p> -->

                  </td>
                  
                   <!-- <td class="sorting_1">
                      {{S.lastUpdated | formatDate}}
                   </td> -->
                  <td class="sorting_1 text-center">
                    <p id="labelNotArrived" v-if="S.status == ''">Not Arrived</p>
                    <p id="labelGreen" v-if="S.status != ''"> {{ capitalizeFirstLetter(S.status) }} </p>
                  </td>

                   <td class="sorting_1">

                    <!-- <button type="button" class="btn btn-link" v-on:click="editSetup(S);" data-toggle="modal" data-target="#editModal">
                        Edit
                    </button> -->

                    <button type="button" class="btn btn-link" v-on:click="editIDCard(S);">
                        Edit
                    </button>

                  </td>

                </tr>
                </template> 
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- /.box-body -->
    </div>

    <!-- Edit Modal -->

    <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalCenterTitle">Edit </h3>
          </div>
          <!-- <form v-on:submit.prevent="editSave()"> -->



            <form>
          <div class="modal-body">

            <p>
              <b>Important:</b><br>
              Photo, UID, Name, Mobile, Email & DOB will be displayed on the ID Card.
            </p>

              <!-- <div class="form-group">
                <label for="exampleFormControlInput1">Checkpoint *</label>
                <input type="text" v-model="checkPointName" class="form-control" id="exampleFormControlInput1" placeholder required>
              </div> -->

                  <div class="form-group" v-for="(value, key) in editInfo" :key="key">
                    <label :for="key">{{ capitalizeFirstLetter(key) }}</label>
                    <input type="text" :id="key" v-model="editInfo[key]" class="form-control" placeholder>
                  </div>

              <!-- <div class="form-group">
                <label for="exampleFormControlInput1">Registration Type</label>
                <select v-model="formInfo.regType" class="form-control" id="exampleFormControlInput1">
                   <option value=""></option>
                   <option value="Residential">Residential</option>
                   <option value="Non Residential">Non Residential</option>
                </select>
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Package Name</label>
                <input type="text" v-model="formInfo.packageName" class="form-control" id="exampleFormControlInput1" placeholder="">
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Person Type</label>
                <input type="text" v-model="formInfo.personType" class="form-control" id="exampleFormControlInput1" placeholder="">
              </div>

              <div class="form-group">
                <label for="exampleFormControlInput1">Age (for below 12 years old)</label>
                <input type="text" v-model="formInfo.age" class="form-control" id="exampleFormControlInput1" placeholder="">
              </div> -->

          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
            <!-- <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="AddGroup()">Save</button> -->
            <!-- <button type="submit" class="btn btn-primary" data-dismiss="modal" v-on:click="editSave()">Save & Generate ID Card</button> -->
            <button type="submit" class="btn btn-primary" v-on:click="editSave()">Save & Generate ID Card</button>
            <br>
            <p v-if="showLoading2">Please wait...</p>
            <!-- <button type="submit" class="btn btn-primary">Save</button> -->
          </div>
        </form>
        </div>
      </div>
    </div>

    <!-- end of modal -->


  </div>
  </div>
</section>
</template>

<script>

import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import Autocomplete from 'vuejs-auto-complete'
import {
  globalStore
} from '../../main.js';

// Require needed datatables modules

// import 'datatables.net-bs4';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';


export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      alertMessage: "Please wait...",
      showPleaseWait: false,
      FormInfo: {},
      clientId: globalStore.clientId,
      url: globalStore.url,
      table: '',
      List: [],
      Checkpoints: [],
      showLoading: true,
      showLoading2: false,
      showTable: false,
      Total: 0,
      Arrived: 0,
      NotArrived: 0,
      LinkOpened: 0,
      eventId: globalStore.eventId,
      eventInfo: {},
      rsvpInfo: {}, // for whatsapp api
      tableHeader: {},
      formInfo: {
        name: "",
        mobile: "",
        email: "",
        regNo: " - ",
        regType: " - ",
        packageName: " - ",
        personType: " - "
      },
      analytics: [],
      stats: [],
      idCardStats: [],
      Count: {
        Total: 0,
        Arrived: 0,
        NotArrived: 0
      },
      editId: "",
      editInfo: {}
    }
  },
  mounted() {

    this.showLoading = true;

    console.log("RSVP Component Loaded...");

    console.log("eventId: "+this.eventId);
    console.log("clientId: "+this.clientId);    
    console.log("url: "+globalStore.url);

    // this.tempFunc();

    //get eventInfo

    if(localStorage.getItem('clientId') && localStorage.getItem('eventId')){
        console.log("Already Logged In");
        console.log("eventId: "+localStorage.getItem('eventId'));
        console.log("clientId: "+localStorage.getItem('clientId'));

        this.GetEventInfo();

      }
      else{
        console.log("Not Logged In")
      }

  },
  methods: {
    capitalizeFirstLetter(str) {
          if (!str) return ''; // Return empty string if the input is empty
            return str.charAt(0).toUpperCase() + str.slice(1);
    },
    tempFunc(){

      console.log("Temp Function");

      setTimeout(() => {
        
        setInterval(() => {
          this.Arrived++;
          this.NotArrived--;
        }, 1200);

      }, 10000);
    


    },
    sendWhatsappPrompt(info){

      console.log(info.mobile);

      Swal.fire({
      title: 'Enter Mobile',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      inputValue: info.mobile,
      showCancelButton: true,
      confirmButtonText: 'Send Whatsapp',
      showLoaderOnConfirm: true,
      preConfirm: (mobile) => {

        // Handle the input value here
        // For example, you can save it to data property or send to server
        console.log("User input:", mobile);

        info.mobile = mobile;

        console.log("New Mobile: "+info.mobile);

        this.sendWhatsapp(info);

      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle the confirmation here
      }
    })      

    },
    sendIDCardPrompt(info){

      const Swal = require('sweetalert2')        

            // Swal.fire({
            //     title: 'Sorry!',
            //     // html:'<h2>'+info.status+'</h2>',
            //     html:'Template Approval In Progress.',
            //     type: 'error',
            //     showConfirmButton: false,
            //     // timer: 1500
            //   })   

      console.log(info.mobile);

      Swal.fire({
      title: 'Enter Mobile to Send ID Card',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      inputValue: info.mobile,
      showCancelButton: true,
      confirmButtonText: 'Send Whatsapp',
      showLoaderOnConfirm: true,
      preConfirm: (mobile) => {

        // Handle the input value here
        // For example, you can save it to data property or send to server
        console.log("User input:", mobile);

        info.mobile = mobile;

        console.log("New Mobile: "+info.mobile);

        const Swal = require('sweetalert2')        

        this.sendWhatsappIDCard(info);

      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle the confirmation here
      }
    })      

    },
    getAnalytics_dep(){

          console.log("Get Analytics...");

          axios.get(
            globalStore.url+ `/api/conf-analytics/`+globalStore.eventId
            ).then(response => {
              console.log("Get Conf Analytics API Response");

              console.log(response)

              this.analytics = response.data;

              console.log("Analytics: "+this.analytics.length)

            });

    },
    getAnalytics(){

          console.log("Get Analytics...");

          axios.get(
            globalStore.url+ `/api/cyl-stats`
            ).then(response => {
              console.log("Get cyl-stats Info API Response");

              console.log(response)

              this.stats = response.data;
              console.log("Length: "+this.stats.length);

              this.Total = 0;
              this.Arrived = 0;
              this.NotArrived = 0;

              this.stats.map((val)=>{
                console.log(val._id+" "+val.arrived+" "+val.notArrived);
                this.Total = this.Total + val.arrived + val.notArrived;
                this.Arrived = this.Arrived + val.arrived;
                this.NotArrived = this.NotArrived + val.notArrived;
              });



            }).catch(e => {

              console.log("Error :"+JSON.stringify(e));

              this.showStatsLoading = false;
              this.showStats = true;

            });               



              axios.get(
                globalStore.url+ `/api/cyl-stats-idcard`
                ).then(response => {
                  console.log("Get cyl-stats-idcard Info API Response");

                  console.log(response)
                  this.idCardStats = response.data;
                  console.log("Length: "+this.idCardStats.length);

                  this.stats.map((val)=>{
                    console.log(val._id+" "+val.saved+" "+val.pending);
                  });



                }).catch(e => {

                  console.log("Error :"+JSON.stringify(e));

                  this.showStatsLoading = false;
                  this.showStatsIDCard = true;


                });   




            
    },
    GetEventInfo(){

      console.log("Get Event Info")
      console.log("EventId: "+this.eventId); 

      axios.get(
        globalStore.url+ `/api/get-eventInfo/`+this.eventId
        ).then(response => {
          console.log("Get Event Info API Response");

          console.log(response)
          this.eventInfo = response.data[0];

          globalStore.eventInfo = response.data[0];

          console.log("Event Name: "+this.eventInfo.eventName);

          // setTimeout(() => {

            
                        // get all registrations for eventId
            this.GetRegistrations();
            this.GetCheckPoints();
            this.getAnalytics();
            
          // }, 1000);





        }).catch(e => {
          alert(e);
          console.log("Error :"+JSON.stringify(e));
        });


    },
    GetCheckPoints(){

      console.log("Get Checkpoints");
      console.log("EventId: "+this.eventId);

      axios.get(
        globalStore.url+ `/checkPoints/`+globalStore.clientId
        ).then(response => {
          console.log("Get All Checkpoints API Response");

          console.log(response)

          this.List = response.data;
          console.log(this.List);
          console.log("Total Checkpoints for client: "+this.List.length)

          this.List.map((info)=>{

            if(info.eventId._id == this.eventId){
              this.Checkpoints.push(info);
            }
          })



          setTimeout(() => {
            console.log("Total Checkpoints for Event: "+this.Checkpoints.length)
          }, 1000);



        }).catch(e => {
          // alert(e);
          // alert("1");
          console.log("Error :"+JSON.stringify(e));
        });      

    },
    GetRegistrations(){

      console.log("Get All Registrations");

      const config = {
        headers:{
          Authorization: globalStore.token,
        }
      };

      console.log("EventId: "+this.eventId);

      axios.get(
        globalStore.url+ `/api/get-all-rsvp-event2/`+this.eventId 
        ).then(response => {
          console.log("Get All Registrations API Response");

          console.log(response)


            this.List = response.data;

            // this.tableHeader = this.List[0];

            this.tableHeader = this.eventInfo;


            console.log(this.List);
            this.Total = this.List.length;
            console.log("Total Registrations: "+this.List.length)
            
            this.showLoading = false;
            this.showTable = true;

            // this.CalculateDashboard();

            setTimeout(() => {
              this.DisplayTable();
            }, 500);

          


        }).catch(e => {
          // alert(e);
          // alert(2);
          console.log("Error :"+JSON.stringify(e));
        });

    },
    CalculateDashboard(){

      this.Arrived = 0;
      this.NotArrived = 0;
      this.LinkOpened = 0;

        this.List.map((info)=>{

          console.log(info.status);

          if(info.linkOpened == true){
            this.LinkOpened++;
          }

          if(info.status == 'arrived'){
            this.Arrived++;
          }else if(info.status == ''){
            this.NotArrived++;
          }



        });
    },
    Add(){

      console.log("Add Walk-In");

      this.showLoading2 = true;

      console.log(this.formInfo);

      var payload = {
        eventId: this.eventId,
        clientId: this.clientId,
        name: this.formInfo.name,
        email: this.formInfo.email,
        mobile: this.formInfo.mobile,
        status: "",
        customFields: {
          batch: "WalkIn",
          rsvpInfo: this.formInfo
        },
        autoEmail: this.eventInfo.customFields.autoEmail,
        fromEmail: "hello@visity.io",
        qrcodeUrl: "https://qrcode.visity.io"
      };

      console.log("Payload: "+JSON.stringify(payload));

        axios.post(globalStore.url + `/api/add-rsvp-v2`, payload).then((res) => {
          console.log(res)

          var url = res.data.data.eTicketUrl;
          console.log("QR Code URL: "+url)

          // console.log(JSON.stringify(res));
          this.sendWhatsapp(url);

        }).catch((e) => {
          console.log("error is : " + e);
          swal("Oops!", "Something went wrong. Please contact support!", "error");
        });      



    },
    sendWhatsapp(info){

            console.log("Send Whatsapp");

            // console.log(info.name);
            // console.log(info.mobile);
            // console.log(info.eTicketUrl);

            console.log(info.customFields.rsvpInfo.name);
            console.log(info.mobile);
            console.log(info.customFields.rsvpInfo.category);

            const url = 'https://live-server-1238.wati.io/api/v1/sendTemplateMessage?whatsappNumber=' + info.mobile;
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0YTIwNmQ0OS1lZTE1LTRlOGEtOGE4My02N2MxZmVmYWFiMWMiLCJ1bmlxdWVfbmFtZSI6Im9ubGluZUBzbmVod29ybGQuY29tIiwibmFtZWlkIjoib25saW5lQHNuZWh3b3JsZC5jb20iLCJlbWFpbCI6Im9ubGluZUBzbmVod29ybGQuY29tIiwiYXV0aF90aW1lIjoiMDYvMDYvMjAyNCAwNTo1NjoyOSIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJ0ZW5hbnRfaWQiOiIxMjM4IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQURNSU5JU1RSQVRPUiIsImV4cCI6MjUzNDAyMzAwODAwLCJpc3MiOiJDbGFyZV9BSSIsImF1ZCI6IkNsYXJlX0FJIn0.h5NOZfrzYxhmcUbETn6Wj3xem2oy674-MvQz46mBEOE'
                },
                data: JSON.stringify({
                    broadcast_name: 'qr_cyl_one_admin_panel',
                    parameters: [
                        { name: 'name', value: info.customFields.rsvpInfo.name },
                        { name: 'category_name', value: info.customFields.rsvpInfo.category },
                        { name: 'QRCode_URL', value: info.eTicketUrl }
                    ],
                    template_name: 'cyl_qr_ticket_16thto18thaug24'
                })
            };
            
            axios(url, options)
                .then(response => {
                    console.log(info.name + " " + info.mobile + " " + info.category);
                    return response.data; // Assuming you want to do something with the data
                })
                .then(data => {
                    // You can handle the data here if needed
                    console.log("-- Data Processed --");

                    Swal.fire({
                        title: 'Success!',
                        text: 'Whatsapp has been sent successfully.',
                        icon: 'success',
                        confirmButtonText: 'Ok'
                      });                

                })
                .catch(error => {
                    console.log("------- ERROR -------");
                    console.log(info.name + " " + info.mobile + " " + info.category);
                    console.error('error:' + error);
                    console.log("--- xxx ---");

                    const Swal = require('sweetalert2')
                      Swal.fire({
                        title: 'Sorry!',
                        // html:'<h2>'+info.status+'</h2>',
                        html:'Something went wrong. Please try again.',
                        type: 'error',
                        showConfirmButton: false,
                        // timer: 1500
                      })                    

                });            


    },
    sendWhatsappIDCard(info){

            console.log("Send ID Card via Whatsapp");

            // console.log(info.name);
            // console.log(info.mobile);
            // console.log(info.eTicketUrl);

            console.log(info.customFields.rsvpInfo.name);
            console.log(info.mobile);
            console.log(info._id);

            const url = 'https://live-server-1238.wati.io/api/v1/sendTemplateMessage?whatsappNumber=' + info.mobile;
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                     Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0YTIwNmQ0OS1lZTE1LTRlOGEtOGE4My02N2MxZmVmYWFiMWMiLCJ1bmlxdWVfbmFtZSI6Im9ubGluZUBzbmVod29ybGQuY29tIiwibmFtZWlkIjoib25saW5lQHNuZWh3b3JsZC5jb20iLCJlbWFpbCI6Im9ubGluZUBzbmVod29ybGQuY29tIiwiYXV0aF90aW1lIjoiMDYvMDYvMjAyNCAwNTo1NjoyOSIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJ0ZW5hbnRfaWQiOiIxMjM4IiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQURNSU5JU1RSQVRPUiIsImV4cCI6MjUzNDAyMzAwODAwLCJpc3MiOiJDbGFyZV9BSSIsImF1ZCI6IkNsYXJlX0FJIn0.h5NOZfrzYxhmcUbETn6Wj3xem2oy674-MvQz46mBEOE'
                },
                data: JSON.stringify({
                    broadcast_name: 'cyl_idcard_admin_panel',
                    parameters: [
                        { name: 'name', value: info.name },
                        { name: 'var', value: info._id }
                    ],
                    template_name: 'generateid_visity'
                })
            };
            
            axios(url, options)
                .then(response => {
                    console.log(info.name + " " + info.mobile);
                    return response.data; // Assuming you want to do something with the data
                })
                .then(data => {
                    // You can handle the data here if needed
                    console.log("-- Data Processed --");

                    Swal.fire({
                        title: 'Success!',
                        text: 'Whatsapp has been sent successfully.',
                        icon: 'success',
                        confirmButtonText: 'Ok'
                      });                

                })
                .catch(error => {
                    console.log("------- ERROR -------");
                    console.log(info.name + " " + info.mobile + " " + info.category);
                    console.error('error:' + error);
                    console.log("--- xxx ---");

                    const Swal = require('sweetalert2')
                      Swal.fire({
                        title: 'Sorry!',
                        // html:'<h2>'+info.status+'</h2>',
                        html:'Something went wrong. Please try again.',
                        type: 'error',
                        showConfirmButton: false,
                        // timer: 1500
                      })                    

                });      

    },
    editIDCard(info){

      console.log("Edit ID Card");

      console.log(info._id);

      const rsvpId = info._id;

      // Build the query params
      const queryParams = { rsvpId };

      // Use $router.resolve to construct the URL for the new route
      const url = this.$router.resolve({
        path: 'edit-id-card',
        query: queryParams
      }).href;

      // Open the constructed URL in a new tab
      window.open(url, '_blank');

      // // Navigate to the route and pass the object
      // this.$router.push({ 
      //   name: 'edit-id-card', 
      //   params: { info } 
      // });      

    },
    editSetup(info){

        console.log("Edit Setup");

        console.log(info);

        this.editId = info._id;
        this.editInfo = info.customFields.rsvpInfo;

        console.log("id: "+this.editId);
        console.log("Info: "+this.editInfo);

    },
    editSave(){

      this.alertMessage = "Please wait...";
      this.showPleaseWait = true;

      console.log("Save");

      console.log(this.editInfo);
      console.log(JSON.stringify(this.editInfo));

      var payload = {
        rsvpId: this.editId,
        rsvpInfo: this.editInfo
      }

      console.log("Payload: "+JSON.stringify(payload));
      console.log("Payload: "+payload);

      axios.put(
            globalStore.url+ `/api/update-rsvpinfo`,payload
            ).then(response => {
              console.log("Update rsvpInfo API Response");

              console.log(response)

              this.alertMessage = "Saved Successfully."

              setTimeout(() => {
                
                this.showPleaseWait = false;

              }, 3000);

                $('#example').DataTable().destroy();

                this.DisplayTable();

              // location.reload();

            }).catch(e => {
              alert(e);
              console.log("Error :"+JSON.stringify(e));
            });


    },
    DisplayTable(){
      setTimeout(() => {
        this.$nextTick(() => {

          let table = $('#example').DataTable({
            autoWidth: true,
            sDom: 'lriftpB',
            buttons: [{
              extend: 'csvHtml5',
              text: 'Export as .CSV',
              title: this.eventInfo.eventName
            }]
          });


          this.isLoading = false
        })
      }, 1000)
    }
  }
}
</script>

<style scoped>
/* .btn-warning,
.btn-danger {
  width: 5em;
} */

.card{
  border: 1px solid rgb(207, 207, 207);
  border-radius: 5px;
  padding: 1em;
  display: flex;
  flex-direction: row;
}


.dash{
  padding: 1em;
  text-align: center;
}

.eventDetails{
  padding-left: 1em;
}

h3{
  color: #000000;
}

.btn-outline-danger{
  background-color: #ffffff;
  border: 1px solid red;
  color: red;
}

.btn-outline-danger:focus{
  background-color: red;
  border: 1px solid red;
  color: #ffffff;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.editor {
  /* height: 300px; */
  border-style: solid;
  border-width: 1px;
}

.editormenu {
  border-bottom: 1px solid;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

.dt-button .buttons-csv .buttons-html5{
  width: 5em;
}

.timeline-footer a.btn {
  margin-right: 10px;
}


tfoot input {
  width: 10%;
  padding: 3px;
  box-sizing: border-box;
}

.statusButton{
  text-transform: capitalize;
  width: 7em;
  /* font-weight: bold; */
  letter-spacing: normal;
}

.searchFilter{
  padding: 2em;
}

.searchButton{
  margin-top: 2em;
}



.fa-exclamation-circle{
  color: orange;
}


.Total{
  /* border: 1px solid #268AFC;  */
  background-color: #268AFC;
  color:#ffffff;
}

.Arrived{
  /* border: 1px solid #46B996;  */
  background-color: #46B996;
  color:#ffffff;
}

.NotArrived{
  background: #EB455A;
  color: #ffffff;
  /* border-radius: 1em; */
}

.LinkOpened{
  background: #FD9A33;
  color: #ffffff;
  /* border-radius: 1em; */
}

#labelNotArrived{
  color: #eb445a  
}

#labelGreen{
  color: #46B996  
}

</style>



// WEBPACK FOOTER //
// Registrations.vue?411683b7